import { LucideIcon, Banknote, Home, Shield, Zap } from "lucide-react";

export interface OwnerExclusiveService {
  id: string;
  tag: string;
  title: string;
  description: string;
  icon: LucideIcon;
  contactPhone: string;
  whatsappMessage: string;
}

export const OWNER_EXCLUSIVE_SERVICES: OwnerExclusiveService[] = [
  {
    id: "rent-anticipation",
    tag: "Benefício financeiro",
    title: "Antecipação de aluguel",
    description:
      "Receba antecipadamente até 24 meses de aluguel e tenha mais liberdade para investir, reformar ou organizar seu planejamento financeiro.",
    icon: Banknote,
    contactPhone: "5585986173316",
    whatsappMessage: "Olá! Sou proprietário 7Cantos e quero saber mais sobre antecipação de aluguel.",
  },
  {
    id: "home-equity",
    tag: "Crédito",
    title: "Home Equity",
    description:
      "Utilize seu imóvel como garantia para contratar crédito com condições diferenciadas e obtenha até 60% do valor do imóvel.",
    icon: Home,
    contactPhone: "5585986173316",
    whatsappMessage: "Olá! Sou proprietário 7Cantos e quero saber mais sobre Home Equity.",
  },
  {
    id: "insurance",
    tag: "Proteção",
    title: "Seguros",
    description:
      "Proteja seu patrimônio com opções de seguro residencial, incêndio, veículo e outras coberturas para você e sua família.",
    icon: Shield,
    contactPhone: "558520284299",
    whatsappMessage: "Olá! Sou proprietário 7Cantos e quero saber mais sobre seguros.",
  },
  {
    id: "energy-savings",
    tag: "Economia",
    title: "Economia na conta de energia",
    description:
      "Reduza seus gastos com energia elétrica e obtenha até 20% de desconto na sua conta sem precisar realizar obras ou trocar equipamentos.",
    icon: Zap,
    contactPhone: "558520284299",
    whatsappMessage:
      "Olá! Sou proprietário 7Cantos e quero saber mais sobre economia na conta de energia.",
  },
];
